<template>
  <div class="loading-small">
    <LoaderIcon class="loading-small__spinner" />
  </div>
</template>

<script>
import LoaderIcon from '@/assets/icons/spin_icon.svg'

export default {
  name: 'LoadingSmallSpinner',
  components: {
    LoaderIcon: { name: 'LoaderIcon', ...LoaderIcon },
  },
}
</script>

<style lang="scss" scoped>
.loading-small {
  line-height: 0;
  &__spinner {
    animation-name: spin;
    animation-duration: 2000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}
</style>
